export default __webpack_public_path__ + "static/media/kandolab.cad6fa02.svg";